module.exports = __webpack_public_path__ + "static/logo2-24b9acef305121c5a7389ca9514847c6.jpg";